import './App.css';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import { ShareContext } from './context/ShareContext';
import Header from './components/Header/Header';
import Gazette from './pages/Gazette/Gazette';
import Categories from './pages/Categories/Categories';
import Payment from './pages/Payment/Payment';
import Receipt from './pages/Receipt/Receipt';
import Upload from './pages/Upload/Upload';
import DocumentUpload from './pages/DocumentUpload/DocumentUpload';
import CreateCase from './pages/CreateCase/CreateCase';
import Eswearing from './pages/Eswearing/Eswearing';
import { useState } from 'react';
import Preview from './pages/Preview/Preview';
import MapGazette from './pages/Gazette/MapGazette';
import MapCategories from './pages/Categories/MapCategories';
import ViewDoc from './pages/ViewDoc/ViewDoc';
import ViewDocTemplate from './pages/ViewDoc/ViewDocTemplate';
import CfoTable from './pages/CFOTable/CfoTable';

import Search from './pages/Search/Search';
import Signup from './pages/Signup/Signup';
import Documents from './pages/Eswearing/documents';

import DMDashboard from './pages/Dashboard/Home/DMDashboard';
import CreateDMTemp from './pages/Dashboard/CreateTemp/CreateDMTemp';
import CreateTemplate from './pages/Templates/CreateTemplate';
import ViewTemplate from './pages/Templates/ViewTemplate';
import Affidavit from './pages/Dashboard/AffidavitTemp/Affidavit';
import CaseDocTemp from './pages/Dashboard/CaseDocTemp/CaseDocTemp';
import CreateDoc from './pages/Dashboard/CreateDoc/CreateDoc';
import Appointment from './pages/Dashboard/CFO-Appointments/Appointment';
import ApproveFiles from './pages/Eswearing/approvefiles';
import GazetteModify from './pages/Gazette/GazetteModify';
import Templates from './pages/Templates/Template';
import LiveDocument from './pages/Dashboard/LiveDocument/LiveDocument';
import VerifiedDocument from './pages/Payment/verifieddocument';

import Profile from './pages/profile/profile';
import Setting from './pages/profile/setting';
import GazetteADR from './pages/Gazette/Gazette_adr';
import AffidavitDocuments from './pages/Templates/AffidavitDocuments';
import ViewAffidavits from './pages/Templates/ViewAffidavits';
import CreateAffidavit from './pages/Templates/CreateAffidavit';
import GazetteModifyAdr from './pages/Gazette/GazetteModifyAdr';
import Placeholder from './pages/Dashboard/Placeholders/Placeholder';
import LiveDocumentAdr from './pages/Dashboard/LiveDocument/LiveDocumentAdr';
import PreviewDocument from './pages/Dashboard/LiveDocument/PreviewDocument';
import LiveContentView from './pages/Dashboard/LiveDocument/LiveContentView';
import LiveDocumentFrame from './pages/Dashboard/LiveDocument/LiveDocumentFrame';
import LiveDocumentFrameAdr from './pages/Dashboard/LiveDocument/LiveDocumentFrameAdr';
import LiveAffidavitView from './pages/Dashboard/LiveDocument/LiveAffidavitView';
import Login from './pages/Login/Login';
import ForgetPassword from './pages/Login/ForgetPassword';




function App() {
  const [whichUpload, setWhichUpload] = useState('');
const [profile, setProfile]=useState({});
const [isHeader, setIsHeader] = useState(true);
const [token, setToken] =useState(null);
  return (
    <div className="App">
      <ShareContext.Provider value={{ whichUpload, setWhichUpload,setProfile,profile, setIsHeader,isHeader, token, setToken }}>
        <Router>
         {isHeader && <Header />} 
          <Routes>
            <Route path='/' exact element={<Login />} /> 
            <Route path='/login' exact element={<Login />} />
            <Route path='/signup' exact element={<Signup />} />
            <Route path='/forgetpassword' exact element={<ForgetPassword />} />
            <Route path='/gazette/:caseno/:paymode/:catid/:embed?' exact element={<Gazette />} />
            <Route path='/gazette/modify/:feeid' exact element={<GazetteModify />} />

    

            <Route path='/categories/:caseno/:paymode' exact element={<Categories />} />
            <Route path='/payment-record' exact element={<Payment />} />
            <Route path='/payment/verifieddocument/:refid' exact element={<VerifiedDocument />} />
            <Route path='/payment-receipt/:refid' exact element={<Receipt />} />

            <Route path='/upload/:casefeeid' exact element={<Upload />} />

            <Route path='/upload/documents/:casefeeid' exact element={<DocumentUpload />} />
            <Route path='/upload/documents' exact element={<Documents />} />

            <Route path='/upload/preview' exact element={<Preview />} />
            <Route path='/upload/create-case' exact element={<CreateCase />} />
            <Route path='/upload/e-swearing' exact element={<Eswearing />} />
            <Route path='/:caseno' exact element={<Gazette />} />
            <Route path='/mapgazette/:categoryid' exact element={<MapGazette />} />
            <Route path='/mapcategories' exact element={<MapCategories />} />
            <Route path='/view-document' exact element={<ViewDoc />} />
            <Route path='/view-document-template' exact element={<ViewDocTemplate />} />

            <Route path='/cfo' exact element={<CfoTable />} />
            <Route path='/dashboard' exact element={<DMDashboard />} />
            <Route path='/search' exact element={<Search />} />
            <Route path='/search/:docref' exact element={<Search />} />
            <Route path='/search/DOC/:type/:feeid/:docid/:uplineid' exact element={<Search />} />
            <Route path='/search/:casenumber/:type/:uplineid' exact element={<Search />} />
            <Route path='/search/:v1/:v2/:v3/:v4/:v5' exact element={<Search />} />
            <Route path='/signup' exact element={<Signup />} />

            <Route path='/home/dashboard' exact element={<DMDashboard />} />
            <Route path='/templates/:temptype' exact element={<Templates />} />
            <Route path='/templates/:id/view' exact element={<ViewTemplate />} />
            <Route path='/templates/:type/create' exact element={<CreateTemplate />} />
            <Route path='/templates/:type/:id/edit' exact element={<CreateTemplate />} />
            <Route path='/templates/placeholders' exact element={<Placeholder />} />

            <Route path='/templates/AffidavitDocuments/:refid?' exact element={<AffidavitDocuments />} />
            <Route path='/AffidavitDocuments/:id/view' exact element={<ViewAffidavits />} />
            <Route path='/AffidavitDocuments/:id/create' exact element={<CreateAffidavit />} />
            <Route path='/AffidavitDocuments/:id/edit/:uplineid' exact element={<CreateAffidavit />} />
            <Route path='/AffidavitDocuments/live/content/:id' exact element={<LiveAffidavitView />} /> 

            <Route path='/edm/create-temp' exact element={<CreateDMTemp />} />
            

            <Route path='/affidavit-templates' exact element={<Affidavit />} />
            <Route path='/case-doc-templates' exact element={<CaseDocTemp />} />
            <Route path='/create-document' exact element={<CreateDoc />} />
            <Route path='/cfo/appointments' exact element={<Appointment />} />
            <Route path='/document/files/:type/:id' exact element={<ApproveFiles />} />
            <Route path='/document/files' exact element={<LiveDocument />} />
            <Route path='/document/files/:id' exact element={<LiveDocument />} />
            <Route path='/document-frame/files/:id' exact element={<LiveDocumentFrame />} />
            <Route path='/adr/document/files' exact element={<LiveDocumentAdr />} />
            <Route path='/adr/document/files/:id' exact element={<LiveDocumentAdr />} />
            <Route path='/adr/document-frame/files/:id' exact element={<LiveDocumentFrameAdr />} />
            <Route path='/document/preview/:id' exact element={<PreviewDocument />} /> 
            <Route path='/document/live/content/:type/:id' exact element={<LiveContentView />} /> 
            
            
            <Route path='/profile' exact element={<Profile />} />
            <Route path='/setting' exact element={<Setting />} />
            <Route path='/adr/gazette/:caseno/:embed?' exact element={<GazetteADR />} />
            <Route path='/adr/gazette/modify/:feeid' exact element={<GazetteModifyAdr />} />
          </Routes>
        </Router>
      </ShareContext.Provider>
    </div>
  );
}

export default App;
